module.exports = __webpack_public_path__ + "static/media/wallet-fund-account.a844e720.png";